import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-black/40'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/3b8ad55d4ff58d61aa412f5935e39846/fe8bc750681395e13b124b6ad44e0ad7.jpeg"
              alt="TMI Logo"
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden lg:flex items-center gap-10">
            <Link
              to="/"
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/') 
                  ? 'text-[#8B1538]' 
                  : scrolled 
                    ? 'text-gray-800 hover:text-[#8B1538]' 
                    : 'text-white hover:text-[#8B1538]'
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/about') 
                  ? 'text-[#8B1538]' 
                  : scrolled 
                    ? 'text-gray-800 hover:text-[#8B1538]' 
                    : 'text-white hover:text-[#8B1538]'
              }`}
            >
              About TMI
            </Link>
            <Link
              to="/mining"
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/mining') 
                  ? 'text-[#8B1538]' 
                  : scrolled 
                    ? 'text-gray-800 hover:text-[#8B1538]' 
                    : 'text-white hover:text-[#8B1538]'
              }`}
            >
              Mining
            </Link>
            <Link
              to="/logistics"
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/logistics') 
                  ? 'text-[#8B1538]' 
                  : scrolled 
                    ? 'text-gray-800 hover:text-[#8B1538]' 
                    : 'text-white hover:text-[#8B1538]'
              }`}
            >
              Logistics
            </Link>
            <Link
              to="/product-market"
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/product-market') 
                  ? 'text-[#8B1538]' 
                  : scrolled 
                    ? 'text-gray-800 hover:text-[#8B1538]' 
                    : 'text-white hover:text-[#8B1538]'
              }`}
            >
              Product Market
            </Link>
            <Link
              to="/gallery"
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/gallery') 
                  ? 'text-[#8B1538]' 
                  : scrolled 
                    ? 'text-gray-800 hover:text-[#8B1538]' 
                    : 'text-white hover:text-[#8B1538]'
              }`}
            >
              Gallery
            </Link>
            <Link
              to="/contact"
              className={`text-base font-medium transition-colors whitespace-nowrap ${
                isActive('/contact') 
                  ? 'text-[#8B1538]' 
                  : scrolled 
                    ? 'text-gray-800 hover:text-[#8B1538]' 
                    : 'text-white hover:text-[#8B1538]'
              }`}
            >
              Contact Us
            </Link>
          </div>

          <Link
            to="/contact"
            className="hidden lg:block bg-[#8B1538] text-white px-8 py-3 rounded-lg font-medium hover:bg-[#6B0F2A] transition-colors whitespace-nowrap"
          >
            Get Quote
          </Link>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-800' : 'text-white'}`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-3">
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className={`block w-full text-left py-2 px-4 rounded-lg transition-colors whitespace-nowrap ${
                isActive('/') 
                  ? 'bg-[#8B1538] text-white' 
                  : scrolled 
                    ? 'text-gray-800 hover:bg-gray-100' 
                    : 'text-white hover:bg-white/10'
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              onClick={() => setMobileMenuOpen(false)}
              className={`block w-full text-left py-2 px-4 rounded-lg transition-colors whitespace-nowrap ${
                isActive('/about') 
                  ? 'bg-[#8B1538] text-white' 
                  : scrolled 
                    ? 'text-gray-800 hover:bg-gray-100' 
                    : 'text-white hover:bg-white/10'
              }`}
            >
              About TMI
            </Link>
            <Link
              to="/mining"
              onClick={() => setMobileMenuOpen(false)}
              className={`block w-full text-left py-2 px-4 rounded-lg transition-colors whitespace-nowrap ${
                isActive('/mining') 
                  ? 'bg-[#8B1538] text-white' 
                  : scrolled 
                    ? 'text-gray-800 hover:bg-gray-100' 
                    : 'text-white hover:bg-white/10'
              }`}
            >
              Mining
            </Link>
            <Link
              to="/logistics"
              onClick={() => setMobileMenuOpen(false)}
              className={`block w-full text-left py-2 px-4 rounded-lg transition-colors whitespace-nowrap ${
                isActive('/logistics') 
                  ? 'bg-[#8B1538] text-white' 
                  : scrolled 
                    ? 'text-gray-800 hover:bg-gray-100' 
                    : 'text-white hover:bg-white/10'
              }`}
            >
              Logistics
            </Link>
            <Link
              to="/product-market"
              onClick={() => setMobileMenuOpen(false)}
              className={`block w-full text-left py-2 px-4 rounded-lg transition-colors whitespace-nowrap ${
                isActive('/product-market') 
                  ? 'bg-[#8B1538] text-white' 
                  : scrolled 
                    ? 'text-gray-800 hover:bg-gray-100' 
                    : 'text-white hover:bg-white/10'
              }`}
            >
              Product Market
            </Link>
            <Link
              to="/gallery"
              onClick={() => setMobileMenuOpen(false)}
              className={`block w-full text-left py-2 px-4 rounded-lg transition-colors whitespace-nowrap ${
                isActive('/gallery') 
                  ? 'bg-[#8B1538] text-white' 
                  : scrolled 
                    ? 'text-gray-800 hover:bg-gray-100' 
                    : 'text-white hover:bg-white/10'
              }`}
            >
              Gallery
            </Link>
            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
              className={`block w-full text-left py-2 px-4 rounded-lg transition-colors whitespace-nowrap ${
                isActive('/contact') 
                  ? 'bg-[#8B1538] text-white' 
                  : scrolled 
                    ? 'text-gray-800 hover:bg-gray-100' 
                    : 'text-white hover:bg-white/10'
              }`}
            >
              Contact Us
            </Link>
            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
              className="block w-full bg-[#8B1538] text-white px-8 py-3 rounded-lg font-medium hover:bg-[#6B0F2A] transition-colors whitespace-nowrap text-center"
            >
              Get Quote
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
